export const TACT_COUNTRIES = [
  { label: "Aruba", value: "Aruba" },
  { label: "Afghanistan", value: "Afghanistan" },
  { label: "Angola", value: "Angola" },
  { label: "Anguilla", value: "Anguilla" },
  { label: "Albania", value: "Albania" },
  { label: "Andorra", value: "Andorra" },
  { label: "United Arab Emirates", value: "United Arab Emirates" },
  { label: "Argentina", value: "Argentina" },
  { label: "Armenia", value: "Armenia" },
  { label: "American Samoa", value: "American Samoa" },
  { label: "Antarctica", value: "Antarctica" },
  {
    label: "French Southern Territories",
    value: "French Southern Territories",
  },
  { label: "Antigua and Barbuda", value: "Antigua and Barbuda" },
  { label: "Australia", value: "Australia" },
  { label: "Austria", value: "Austria" },
  { label: "Azerbaijan", value: "Azerbaijan" },
  { label: "Burundi", value: "Burundi" },
  { label: "Belgium", value: "Belgium" },
  { label: "Benin", value: "Benin" },
  { label: "Burkina Faso", value: "Burkina Faso" },
  { label: "Bangladesh", value: "Bangladesh" },
  { label: "Bulgaria", value: "Bulgaria" },
  { label: "Bahrain", value: "Bahrain" },
  { label: "Bahamas", value: "Bahamas" },
  { label: "Bosnia and Herzegovina", value: "Bosnia and Herzegovina" },
  { label: "Belarus", value: "Belarus" },
  { label: "Belize", value: "Belize" },
  { label: "Bermuda", value: "Bermuda" },
  {
    label: "Bolivia (Plurinational State of)",
    value: "Bolivia (Plurinational State of)",
  },
  { label: "Brazil", value: "Brazil" },
  { label: "Barbados", value: "Barbados" },
  { label: "Brunei Darussalam", value: "Brunei Darussalam" },
  { label: "Bhutan", value: "Bhutan" },
  { label: "Bouvet Island", value: "Bouvet Island" },
  { label: "Botswana", value: "Botswana" },
  { label: "Central African Republic", value: "Central African Republic" },
  { label: "Canada", value: "Canada" },
  { label: "Cocos (Keeling) Islands", value: "Cocos (Keeling) Islands" },
  { label: "Switzerland", value: "Switzerland" },
  { label: "Chile", value: "Chile" },
  { label: "China", value: "China" },
  { label: "Côte d'Ivoire", value: "Côte d'Ivoire" },
  { label: "Cameroon", value: "Cameroon" },
  { label: "Congo", value: "Congo" },
  { label: "Cook Islands", value: "Cook Islands" },
  { label: "Colombia", value: "Colombia" },
  { label: "Comoros", value: "Comoros" },
  { label: "Cabo Verde", value: "Cabo Verde" },
  { label: "Costa Rica", value: "Costa Rica" },
  { label: "Cuba", value: "Cuba" },
  { label: "Christmas Island", value: "Christmas Island" },
  { label: "Cayman Islands", value: "Cayman Islands" },
  { label: "Cyprus", value: "Cyprus" },
  { label: "Czech Republic", value: "Czech Republic" },
  { label: "Germany", value: "Germany" },
  { label: "Djibouti", value: "Djibouti" },
  { label: "Dominica", value: "Dominica" },
  { label: "Denmark", value: "Denmark" },
  { label: "Dominican Republic", value: "Dominican Republic" },
  { label: "Algeria", value: "Algeria" },
  { label: "Ecuador", value: "Ecuador" },
  { label: "Egypt", value: "Egypt" },
  { label: "Eritrea", value: "Eritrea" },
  { label: "Western Sahara", value: "Western Sahara" },
  { label: "Spain", value: "Spain" },
  { label: "Estonia", value: "Estonia" },
  { label: "Ethiopia", value: "Ethiopia" },
  { label: "Finland", value: "Finland" },
  { label: "Fiji", value: "Fiji" },
  { label: "Falkland Islands", value: "Falkland Islands" },
  { label: "France", value: "France" },
  { label: "Faroe Islands", value: "Faroe Islands" },
  { label: "Micronesia", value: "Micronesia" },
  { label: "Gabon", value: "Gabon" },
  { label: "United Kingdom", value: "United Kingdom" },
  { label: "Georgia", value: "Georgia" },
  { label: "Ghana", value: "Ghana" },
  { label: "Gibraltar", value: "Gibraltar" },
  { label: "Guinea", value: "Guinea" },
  { label: "Guadeloupe", value: "Guadeloupe" },
  { label: "Gambia", value: "Gambia" },
  { label: "Guinea-Bissau", value: "Guinea-Bissau" },
  { label: "Equatorial Guinea", value: "Equatorial Guinea" },
  { label: "Greece", value: "Greece" },
  { label: "Grenada", value: "Grenada" },
  { label: "Greenland", value: "Greenland" },
  { label: "Guatemala", value: "Guatemala" },
  { label: "French Guiana", value: "French Guiana" },
  { label: "Guam", value: "Guam" },
  { label: "Guyana", value: "Guyana" },
  { label: "Hong Kong", value: "Hong Kong" },
  {
    label: "Heard Island and McDonald Islands",
    value: "Heard Island and McDonald Islands",
  },
  { label: "Honduras", value: "Honduras" },
  { label: "Croatia", value: "Croatia" },
  { label: "Haiti", value: "Haiti" },
  { label: "Hungary", value: "Hungary" },
  { label: "Indonesia", value: "Indonesia" },
  { label: "India", value: "India" },
  {
    label: "British Indian Ocean Territory",
    value: "British Indian Ocean Territory",
  },
  { label: "Ireland", value: "Ireland" },
  { label: "Iran", value: "Iran" },
  { label: "Iraq", value: "Iraq" },
  { label: "Iceland", value: "Iceland" },
  { label: "Israel", value: "Israel" },
  { label: "Italy", value: "Italy" },
  { label: "Jamaica", value: "Jamaica" },
  { label: "Jordan", value: "Jordan" },
  { label: "Japan", value: "Japan" },
  { label: "Kazakhstan", value: "Kazakhstan" },
  { label: "Kenya", value: "Kenya" },
  { label: "Kyrgyzstan", value: "Kyrgyzstan" },
  { label: "Cambodia", value: "Cambodia" },
  { label: "Kiribati", value: "Kiribati" },
  { label: "Saint Kitts And Nevis", value: "Saint Kitts And Nevis" },
  { label: "Korea (Republic of)", value: "Korea (Republic of)" },
  { label: "Kuwait", value: "Kuwait" },
  { label: "Laos", value: "Laos" },
  { label: "Lebanon", value: "Lebanon" },
  { label: "Liberia", value: "Liberia" },
  { label: "Libya", value: "Libya" },
  { label: "Saint Lucia", value: "Saint Lucia" },
  { label: "Liechtenstein", value: "Liechtenstein" },
  { label: "Sri Lanka", value: "Sri Lanka" },
  { label: "Lesotho", value: "Lesotho" },
  { label: "Lithuania", value: "Lithuania" },
  { label: "Luxembourg", value: "Luxembourg" },
  { label: "Latvia", value: "Latvia" },
  { label: "Macao", value: "Macao" },
  { label: "Morocco", value: "Morocco" },
  { label: "Monaco", value: "Monaco" },
  { label: "Moldova", value: "Moldova" },
  { label: "Madagascar", value: "Madagascar" },
  { label: "Maldives", value: "Maldives" },
  { label: "Mexico", value: "Mexico" },
  { label: "Marshall Islands", value: "Marshall Islands" },
  { label: "Macedonia", value: "Macedonia" },
  { label: "Mali", value: "Mali" },
  { label: "Malta", value: "Malta" },
  { label: "Myanmar", value: "Myanmar" },
  { label: "Mongolia", value: "Mongolia" },
  { label: "Northern Mariana Islands", value: "Northern Mariana Islands" },
  { label: "Mozambique", value: "Mozambique" },
  { label: "Mauritania", value: "Mauritania" },
  { label: "Montserrat", value: "Montserrat" },
  { label: "Martinique", value: "Martinique" },
  { label: "Mauritius", value: "Mauritius" },
  { label: "Malawi", value: "Malawi" },
  { label: "Malaysia", value: "Malaysia" },
  { label: "Mayotte", value: "Mayotte" },
  { label: "Namibia", value: "Namibia" },
  { label: "New Caledonia", value: "New Caledonia" },
  { label: "Niger", value: "Niger" },
  { label: "Norfolk Island", value: "Norfolk Island" },
  { label: "Nigeria", value: "Nigeria" },
  { label: "Nicaragua", value: "Nicaragua" },
  { label: "Niue", value: "Niue" },
  { label: "Netherlands", value: "Netherlands" },
  { label: "Norway", value: "Norway" },
  { label: "Nepal", value: "Nepal" },
  { label: "Nauru", value: "Nauru" },
  { label: "New Zealand", value: "New Zealand" },
  { label: "Oman", value: "Oman" },
  { label: "Pakistan", value: "Pakistan" },
  { label: "Panama", value: "Panama" },
  { label: "Pitcairn", value: "Pitcairn" },
  { label: "Peru", value: "Peru" },
  { label: "Philippines", value: "Philippines" },
  { label: "Palau", value: "Palau" },
  { label: "Papua New Guinea", value: "Papua New Guinea" },
  { label: "Poland", value: "Poland" },
  { label: "Puerto Rico", value: "Puerto Rico" },
  { label: "Portugal", value: "Portugal" },
  { label: "Paraguay", value: "Paraguay" },
  { label: "French Polynesia", value: "French Polynesia" },
  { label: "Qatar", value: "Qatar" },
  { label: "Réunion", value: "Réunion" },
  { label: "Romania", value: "Romania" },
  { label: "Russia", value: "Russia" },
  { label: "Rwanda", value: "Rwanda" },
  { label: "Saudi Arabia", value: "Saudi Arabia" },
  { label: "Sudan", value: "Sudan" },
  { label: "Senegal", value: "Senegal" },
  { label: "Singapore", value: "Singapore" },
  {
    label: "South Georgia and the South Sandwich Islands",
    value: "South Georgia and the South Sandwich Islands",
  },
  { label: "Saint Helena", value: "Saint Helena" },
  { label: "Svalbard", value: "Svalbard" },
  { label: "Solomon Islands", value: "Solomon Islands" },
  { label: "Sierra Leone", value: "Sierra Leone" },
  { label: "El Salvador", value: "El Salvador" },
  { label: "San Marino", value: "San Marino" },
  { label: "Somalia", value: "Somalia" },
  { label: "Saint Pierre and Miquelon", value: "Saint Pierre and Miquelon" },
  { label: "Sao Tome and Principe", value: "Sao Tome and Principe" },
  { label: "Suriname", value: "Suriname" },
  { label: "Slovakia", value: "Slovakia" },
  { label: "Slovenia", value: "Slovenia" },
  { label: "Sweden", value: "Sweden" },
  { label: "Swaziland", value: "Swaziland" },
  { label: "Seychelles", value: "Seychelles" },
  { label: "Syria", value: "Syria" },
  { label: "Turks and Caicos Islands", value: "Turks and Caicos Islands" },
  { label: "Chad", value: "Chad" },
  { label: "Togo", value: "Togo" },
  { label: "Thailand", value: "Thailand" },
  { label: "Tajikistan", value: "Tajikistan" },
  { label: "Tokelau", value: "Tokelau" },
  { label: "Turkmenistan", value: "Turkmenistan" },
  { label: "Tonga", value: "Tonga" },
  { label: "Trinidad and Tobago", value: "Trinidad and Tobago" },
  { label: "Tunisia", value: "Tunisia" },
  { label: "Turkey", value: "Turkey" },
  { label: "Tuvalu", value: "Tuvalu" },
  { label: "Taiwan", value: "Taiwan" },
  { label: "Tanzania", value: "Tanzania" },
  { label: "Uganda", value: "Uganda" },
  { label: "Ukraine", value: "Ukraine" },
  {
    label: "United States Minor Outlying Islands",
    value: "United States Minor Outlying Islands",
  },
  { label: "Uruguay", value: "Uruguay" },
  { label: "United States", value: "United States" },
  { label: "Uzbekistan", value: "Uzbekistan" },
  { label: "Vatican City", value: "Vatican City" },
  {
    label: "Saint Vincent and The Grenadines",
    value: "Saint Vincent and The Grenadines",
  },
  { label: "Venezuela", value: "Venezuela" },
  { label: "Virgin Islands (British)", value: "Virgin Islands (British)" },
  { label: "Virgin Islands (U.S.)", value: "Virgin Islands (U.S.)" },
  { label: "Vietnam", value: "Vietnam" },
  { label: "Vanuatu", value: "Vanuatu" },
  { label: "Wallis and Futuna", value: "Wallis and Futuna" },
  { label: "Samoa", value: "Samoa" },
  { label: "Yemen", value: "Yemen" },
  { label: "South Africa", value: "South Africa" },
  { label: "Zambia", value: "Zambia" },
  { label: "Zimbabwe", value: "Zimbabwe" },
];

export const INCIDENT_TYPE_OPTIONS = [
  { label: "Bodily Injury", value: "Bodily Injury" },
  { label: "Property Damage", value: "Property Damage" },
];
export const AMAZON_MARKETPLACE_OPTIONS = [
  { value: "www.amazon.co.uk", label: "www.amazon.co.uk" },
  { value: "www.amazon.de", label: "www.amazon.de" },
  { value: "www.amazon.fr", label: "www.amazon.fr" },
  { value: "www.amazon.it", label: "www.amazon.it" },
  { value: "www.amazon.es", label: "www.amazon.es" },
  { value: "www.amazon.eg", label: "www.amazon.eg" },
  { value: "www.amazon.in", label: "www.amazon.in" },
  { value: "www.amazon.co.jp", label: "www.amazon.co.jp" },
  { value: "www.amazon.ca", label: "www.amazon.ca" },
  { value: "www.amazon.cn", label: "www.amazon.cn" },
  { value: "www.amazon.com.br", label: "www.amazon.com.br" },
  { value: "www.amazon.com.mx", label: "www.amazon.com.mx" },
  { value: "www.amazon.com.au", label: "www.amazon.com.au" },
  { value: "www.amazon.ru", label: "www.amazon.ru" },
  { value: "www.amazon.nl", label: "www.amazon.nl" },
  { value: "www.amazon.ae", label: "www.amazon.ae" },
  { value: "www.amazon.sa", label: "www.amazon.sa" },
  { value: "www.junglee.com", label: "www.junglee.com" },
  { value: "www.amazondistribution.in", label: "www.amazondistribution.in" },
  { value: "www.amazon.com.tr", label: "www.amazon.com.tr" },
  { value: "www.amazon.sg", label: "www.amazon.sg" },
  { value: "www.amazon.pl", label: "www.amazon.pl" },
  { value: "www.amazon.se", label: "www.amazon.se" },
  { value: "www.amazon.com.be", label: "www.amazon.com.be" },
  { value: "www.amazon.com.co", label: "www.amazon.com.co" },
  { value: "www.amazon.cl", label: "www.amazon.cl" },
  { value: "www.amazon.com.ng", label: "www.amazon.com.ng" },
  { value: "www.amazon.co.za", label: "www.amazon.co.za" },
  { value: "www.amazon.ie", label: "www.amazon.ie" },
];

export const FULFILMENT_PATH_OPTIONS = [
  { value: "Retail", label: "Retail" },
  { value: "FBA", label: "FBA" },
  { value: "MFN", label: "MFN" },
];

export const INSTALLATION_SOURCE_OPTIONS = [
  { value: "Not installed", label: "Not installed" },
  { value: "Amazon", label: "Amazon" },
  { value: "Third party", label: "Third party" },
  { value: "Not sure", label: "Not sure" },
];

const supportedCountries = new Set([
  "Austria",
  "Belgium",
  "Canada",
  "France",
  "Germany",
  "Italy",
  "Spain",
  "Sweden",
  "United Kingdom",
]);

export const SUPPORTED_SEDGWICK_IPL_INCIDENT_COUNTRIES = TACT_COUNTRIES.filter((country) =>
  supportedCountries.has(country.value)
);
